<template>
  <div class="print-d2" v-loading="loading">
    <template v-for="(item,index) in list">
      <div class="st-box" :key="index">
        <div class="item" v-for="(item2,index2) in item.Students" :key="index2" :class="{ 'bt': index2<5, 'bl': (index2+1)%5==1, 'bt2': index2%40<5 }">
          <div>考场号：{{item2.ExamHallNo}}</div>
          <div>座位号：{{item2.SeatNo}}</div>
          <div>准考证号：{{item2.AdmissionNo}}</div>
          <div>姓名：{{item2.FullName}}</div>
        </div>
      </div>
      <div :key="'a'+index" style="height:20px;" class="no-print"></div>
      <div :key="'b'+index" style="page-break-after:always;" class="break"></div>
    </template>
    <div class="handle-button no-print">
      <el-button icon="el-icon-printer" size="mini" type="primary" @click="print">打印</el-button>
    </div>
  </div>
</template>
<script>
export default {
  beforeMount() {
    this.loading = true;
    var id = this.$route.query.id;
    this.api.list({ ExamId: id }).then(res => {
      this.loading = false;
      if (res.Code == 0) {
        //-------------------------------------------
        // res.Data = [
        //   {
        //     "SeatNo": "01",
        //     "AdmissionNo": "62001",
        //     "FullName": "肖恩正",
        //     "PicUrl": "/Upload/Junior6/202306/17530aad3e0c4bb68a278039bd573ca2.jpg",
        //     "Sex": 1
        //   },
        //   {
        //     "SeatNo": "02",
        //     "AdmissionNo": "62002",
        //     "FullName": "纪沣铄",
        //     "PicUrl": "/Upload/Junior6/202306/9e3f14bc41544cd19c35e02b22e44c0b.jpg",
        //     "Sex": 1
        //   },
        //   {
        //     "SeatNo": "03",
        //     "AdmissionNo": "62003",
        //     "FullName": "李锦玲",
        //     "PicUrl": "/Upload/Junior6/202306/4241e5ba84d2407fa44f2cdbed42e670.jpg",
        //     "Sex": 2
        //   },
        //   {
        //     "SeatNo": "04",
        //     "AdmissionNo": "62004",
        //     "FullName": "谢嘉颖",
        //     "PicUrl": "/Upload/Junior6/202306/8f0ee69f70be46f1bb4855e20d78ed71.jpg",
        //     "Sex": 1
        //   },
        //   {
        //     "SeatNo": "05",
        //     "AdmissionNo": "62005",
        //     "FullName": "黄育炼",
        //     "PicUrl": "/Upload/Junior6/202306/3aa40f3039594379a795186ebaba684e.jpg",
        //     "Sex": 1
        //   },
        //   {
        //     "SeatNo": "06",
        //     "AdmissionNo": "62006",
        //     "FullName": "郑满",
        //     "PicUrl": "/Upload/Junior6/202306/93f17ec95bd24e8e98ecf38c26703c63.jpg",
        //     "Sex": 1
        //   },
        //   {
        //     "SeatNo": "07",
        //     "AdmissionNo": "62007",
        //     "FullName": "胡圻锋",
        //     "PicUrl": "/Upload/Junior6/202306/5ce6ff3db2684dfba3496fc9e6bf9266.jpg",
        //     "Sex": 1
        //   },
        //   {
        //     "SeatNo": "08",
        //     "AdmissionNo": "62008",
        //     "FullName": "洪启航",
        //     "PicUrl": "/Upload/Junior6/202306/4e505a15da4c4cdc9d0ea0a6a8b4d8e3.jpg",
        //     "Sex": 1
        //   },
        //   {
        //     "SeatNo": "09",
        //     "AdmissionNo": "62009",
        //     "FullName": "袁毅阳",
        //     "PicUrl": "/Upload/Junior6/202306/7511c2b6ab974ac5bf769fc4b60b3380.jpg",
        //     "Sex": 1
        //   },
        //   {
        //     "SeatNo": "10",
        //     "AdmissionNo": "62010",
        //     "FullName": "郑经玮",
        //     "PicUrl": "/Upload/Junior6/202306/e7b7f46ba95947a5beab38842fadb6b8.jpg",
        //     "Sex": 1
        //   },
        //   {
        //     "SeatNo": "11",
        //     "AdmissionNo": "62011",
        //     "FullName": "郑炵炜",
        //     "PicUrl": "/Upload/Junior6/202306/62c0ef6d853b4cc6acf658ae83f8a978.jpg",
        //     "Sex": 1
        //   },
        //   {
        //     "SeatNo": "12",
        //     "AdmissionNo": "62012",
        //     "FullName": "郑耀国",
        //     "PicUrl": "/Upload/Junior6/202306/f7a16f0a44054a8aaa1392b227473bcd.jpg",
        //     "Sex": 1
        //   },
        //   {
        //     "SeatNo": "13",
        //     "AdmissionNo": "62013",
        //     "FullName": "陈烁航",
        //     "PicUrl": "/Upload/Junior6/202306/537a82f74262470a895d313594a9c7ac.jpg",
        //     "Sex": 1
        //   },
        //   {
        //     "SeatNo": "14",
        //     "AdmissionNo": "62014",
        //     "FullName": "黄泽坤",
        //     "PicUrl": "/Upload/Junior6/202306/9e87eea9537b4064839e0028a6707a5a.jpg",
        //     "Sex": 1
        //   },
        //   {
        //     "SeatNo": "15",
        //     "AdmissionNo": "62015",
        //     "FullName": "吴垠锋",
        //     "PicUrl": "/Upload/Junior6/202306/952b509421db4065bf23fba9830896fa.jpg",
        //     "Sex": 1
        //   },
        //   {
        //     "SeatNo": "16",
        //     "AdmissionNo": "62016",
        //     "FullName": "刘煊桐",
        //     "PicUrl": "/Upload/Junior6/202306/b265ac8b778341aea2f2f478ed99bd22.jpg",
        //     "Sex": 1
        //   },
        //   {
        //     "SeatNo": "17",
        //     "AdmissionNo": "62017",
        //     "FullName": "郑泽畅",
        //     "PicUrl": "/Upload/Junior6/202306/25b9f4a6704441bf86d0e7568a8be78c.jpg",
        //     "Sex": 1
        //   },
        //   {
        //     "SeatNo": "18",
        //     "AdmissionNo": "62018",
        //     "FullName": "吴泽羽",
        //     "PicUrl": "/Upload/Junior6/202306/488574c0be824367bdcab37c3aa60974.jpg",
        //     "Sex": 1
        //   },
        //   {
        //     "SeatNo": "19",
        //     "AdmissionNo": "62019",
        //     "FullName": "陈润烁",
        //     "PicUrl": "/Upload/Junior6/202306/e710fdf66b81434d94265492f7ccf64f.jpg",
        //     "Sex": 1
        //   },
        //   {
        //     "SeatNo": "20",
        //     "AdmissionNo": "62020",
        //     "FullName": "郑景轩",
        //     "PicUrl": "/Upload/Junior6/202306/4136a43ee0a7469fbb5a49340c2b52b0.jpg",
        //     "Sex": 1
        //   },
        //   {
        //     "SeatNo": "21",
        //     "AdmissionNo": "62021",
        //     "FullName": "陈宏颖",
        //     "PicUrl": "/Upload/Junior6/202306/1f54fbf00afb46ef99948fbe1b695cf7.jpg",
        //     "Sex": 1
        //   },
        //   {
        //     "SeatNo": "22",
        //     "AdmissionNo": "62022",
        //     "FullName": "袁梓乔",
        //     "PicUrl": "/Upload/Junior6/202306/6a6bcdfd42ac4cdb8510c63119b01d87.jpg",
        //     "Sex": 2
        //   },
        //   {
        //     "SeatNo": "23",
        //     "AdmissionNo": "62023",
        //     "FullName": "肖贺元",
        //     "PicUrl": "/Upload/Junior6/202306/5e284b26057e4920a606e2e22e420676.jpg",
        //     "Sex": 1
        //   },
        //   {
        //     "SeatNo": "24",
        //     "AdmissionNo": "62024",
        //     "FullName": "陈昕亮",
        //     "PicUrl": "/Upload/Junior6/202306/bdaa7cd097a44458a93e0edeecf577d6.jpg",
        //     "Sex": 1
        //   },
        //   {
        //     "SeatNo": "25",
        //     "AdmissionNo": "62025",
        //     "FullName": "赖境韵",
        //     "PicUrl": "/Upload/Junior6/202306/a5f32dc3c2144a2e94ea16762900580f.jpg",
        //     "Sex": 1
        //   },
        //   {
        //     "SeatNo": "26",
        //     "AdmissionNo": "62026",
        //     "FullName": "梁晨昊",
        //     "PicUrl": "/Upload/Junior6/202306/238bd6b2024c469d867b2d28f3ad0e26.jpg",
        //     "Sex": 1
        //   },
        //   {
        //     "SeatNo": "27",
        //     "AdmissionNo": "62027",
        //     "FullName": "张佳杰",
        //     "PicUrl": "/Upload/Junior6/202306/76dee2b6cfc344098f7c5a708e93587a.jpg",
        //     "Sex": 1
        //   },
        //   {
        //     "SeatNo": "28",
        //     "AdmissionNo": "62028",
        //     "FullName": "林浚寅",
        //     "PicUrl": "/Upload/Junior6/202306/437c37f0a61947639efca1744732cf96.jpg",
        //     "Sex": 1
        //   },
        //   {
        //     "SeatNo": "29",
        //     "AdmissionNo": "62029",
        //     "FullName": "陈禹铭",
        //     "PicUrl": "/Upload/Junior6/202306/0202185809694f6e833fa517bf158212.jpg",
        //     "Sex": 1
        //   },
        //   {
        //     "SeatNo": "30",
        //     "AdmissionNo": "62030",
        //     "FullName": "郑欣然",
        //     "PicUrl": "/Upload/Junior6/202306/9a5ee8186c0e45abb2ac1021ed049d58.jpg",
        //     "Sex": 1
        //   },
        //   {
        //     "SeatNo": "31",
        //     "AdmissionNo": "62031",
        //     "FullName": "蓝艺焓",
        //     "PicUrl": "/Upload/Junior6/202306/0d7b3bb121bb4186ba5059d92968732f.jpg",
        //     "Sex": 1
        //   },
        //   {
        //     "SeatNo": "32",
        //     "AdmissionNo": "62032",
        //     "FullName": "周童昕",
        //     "PicUrl": "/Upload/Junior6/202306/7314a7e235664baaa90af2b95ed5715b.jpg",
        //     "Sex": 2
        //   },
        //   {
        //     "SeatNo": "33",
        //     "AdmissionNo": "62033",
        //     "FullName": "杨汶滔",
        //     "PicUrl": "/Upload/Junior6/202306/0007d473eb8949e296af6780a196a8cd.jpg",
        //     "Sex": 1
        //   },
        //   {
        //     "SeatNo": "34",
        //     "AdmissionNo": "62034",
        //     "FullName": "王卫铤",
        //     "PicUrl": "/Upload/Junior6/202306/d15d18abcfcb404383ef4fc27b1991a7.jpg",
        //     "Sex": 1
        //   },
        //   {
        //     "SeatNo": "35",
        //     "AdmissionNo": "62035",
        //     "FullName": "郭麓羲",
        //     "PicUrl": "/Upload/Junior6/202306/a1bd98bae23e498fb2250b245660a846.jpg",
        //     "Sex": 1
        //   },
        //   {
        //     "SeatNo": "36",
        //     "AdmissionNo": "62036",
        //     "FullName": "李乐为",
        //     "PicUrl": "/Upload/Junior6/202306/a6e2221a53dd4f3c8247acf36eb2375b.jpg",
        //     "Sex": 1
        //   },
        //   {
        //     "SeatNo": "37",
        //     "AdmissionNo": "62037",
        //     "FullName": "廖奕凡",
        //     "PicUrl": "/Upload/Junior6/202306/2e050ed5507a4bb38a847d53765b0b16.jpg",
        //     "Sex": 1
        //   },
        //   {
        //     "SeatNo": "38",
        //     "AdmissionNo": "62038",
        //     "FullName": "冯文星",
        //     "PicUrl": "/Upload/Junior6/202306/c438c782f7d84f1aaa405eda701472a6.jpg",
        //     "Sex": 1
        //   },
        //   {
        //     "SeatNo": "39",
        //     "AdmissionNo": "62039",
        //     "FullName": "陈衍霓",
        //     "PicUrl": "/Upload/Junior6/202306/3cde958c8dc64781a0f8479fefc8e0f3.jpg",
        //     "Sex": 2
        //   },
        //   {
        //     "SeatNo": "40",
        //     "AdmissionNo": "62040",
        //     "FullName": "郑于麒",
        //     "PicUrl": "/Upload/Junior6/202306/71f443b42f7845b0825e27d020368c8b.jpg",
        //     "Sex": 1
        //   },
        // ];
        //-------------------------------------------
        var list = [];
        res.Data.forEach((e,index) => {
          if((index)%40 == 0) {
            list.push({ Students: [] });
          }
          list[list.length-1].Students.push(e);
        })
        this.list = list;
        // this.list = this.list.concat(this.list);
        // this.list = this.list.concat(this.list);
        // this.list = this.list.concat(this.list);
        // this.list = this.list.concat(this.list);
        // this.list = this.list.concat(this.list);
        // this.list = this.list.concat(this.list);
      } else this.$message.error(res.Msg);
    });
  },
  data() {
    return {
      api: require("@/api/po/examstudent").default,
      list: [],
      loading: false
    };
  },
  methods: {
    print() {
      window.print();
    }
  }
};
</script>
<style lang="scss" scoped>
.print-d2 {
  width: 800px;
  margin: 20px auto 20px;
  .st-box {
    display:flex;
    flex-wrap:wrap;
  }
  .item {
    display: inline-block;
    padding-top: 0.4rem;
    text-indent: 0.9rem;
    font-size: 14px;
    height: 135px;
    line-height: 2.2;
    width: 20%;
    border: 2px solid #000;
    border-left-width: 0;
    border-top-width: 0;
  }
  .handle-button {
    position: fixed;
    top: 10px;
    right: 30px;
  }
  .nextPage {
    page-break-after: always !important;
  }
  .bt {
    border-top-width: 2px !important;
  }
  .bl {
    border-left-width: 2px !important;
  }
  .break {
    display: none;
  }
}
@media print {
  .print-d2 {
    width: 100%;
    margin: 0;
  }
  .st-box {
    padding: 5mm 5mm 0;
  }
  .break {
    display: block !important;
  }
  .bt2 {
    border-top-width: 2px !important;
  }
  .no-print {
    display: none;
  }
}
</style>